/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * Describes what type of reminder should be sent.
 */
export const AssignmentDoneType = /* #__PURE__ */ parsers.exactly('assigned_only', 'all_graders');
